import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-medical-staff',
  templateUrl: './medical-staff.component.html',
  styleUrls: ['./medical-staff.component.scss']
})
export class MedicalStaffComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
